/* eslint-disable no-underscore-dangle */
export default class SessionService {
  constructor(localStorageService) {
    'ngInject';

    this.localStorageService = localStorageService;

    this._user = JSON.parse(localStorageService.get('session.user'));
    this._authToken = localStorageService.get('session.authToken');
    this._reportParams = JSON.parse(localStorageService.get('session.reportParams'));
  }

  get user() {
    return this._user;
  }

  set user(user) {
    this._user = user;
    this.localStorageService.set('session.user', JSON.stringify(user));
  }

  get reportParams() {
    return this._reportParams;
  }

  set reportParams(params) {
    this._reportParams = params;
    this.localStorageService.set('session.reportParams', JSON.stringify(params));
  }

  get authToken() {
    return this._authToken;
  }

  set authToken(token) {
    this._authToken = token;
    this.localStorageService.set('session.authToken', token);
  }

  destroy() {
    this.user = null;
    this.authToken = null;
  }
}



// WEBPACK FOOTER //
// ./services/session.service.js